import { render, staticRenderFns } from "./bottomBtn.vue?vue&type=template&id=2222062c&scoped=true&"
import script from "./bottomBtn.vue?vue&type=script&lang=js&"
export * from "./bottomBtn.vue?vue&type=script&lang=js&"
import style0 from "./bottomBtn.vue?vue&type=style&index=0&id=2222062c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222062c",
  null
  
)

component.options.__file = "bottomBtn.vue"
export default component.exports